<template>
  <transition name="fade">
    <div class="overlay" v-if="show">
      <div class="overlay__inner">
        <div class="panel">
          <div class="panel__header">
            <p><strong>We're rolling it out gradually —and you're invited.</strong>
              Join the early access list for the new Visceral Consignment.
              You will still have access to the current version. But this will grant
              you special access to the new version before we make the switch.</p>
            <span class="overlay__close" @click="$emit('close')">
              <i class="fas fa-times"></i>
            </span>
          </div>
          <div class="panel__content">
            <iframe
              aria-label='Early Access Request'
              frameborder="0"
              style="height:500px;width:100%;border:none;"
              src='https://forms.zohopublic.com/zeptomail1210920227675380301/form/EarlyAccessRequest/formperma/OUbJDSTLxR13nJlMi1L-13bRxT3qOgH1F_HjuYHWdz8'>
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'EarlyAccessModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/components/EarlyAccessModal.vue